import { Avatar } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CounterView = styled(Avatar)(({ theme }) => ({
  width: 24,
  height: 24,
  ...theme.typography.body1,
}));
